import React from 'react';
import {Route, Routes} from 'react-router-dom';
import ConsultaModeloAnuncio from './consulta';
import EditarModeloAnuncio from './editar';

const ModeloAnuncios = () => {
  return (
    <Routes>
      <Route exact path="/" element={<ConsultaModeloAnuncio />} />
      <Route path={`/:modeloAnuncioId`} element={<EditarModeloAnuncio />} />
    </Routes>
  );
};

export default ModeloAnuncios;
